<template>
  <div class="main">
    <springHead title="2020年春季招生"></springHead>
    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/spring/banner.jpg"
    ></landingBanner>
    <div class="content">
      <springForm color="#fff" bag="#be0000" words="查询学费"></springForm>
      <div style="width:100%;height:15px;"></div>
      
      <srcoll></srcoll>
 
      <div style="width:100%;height:25px;"></div>
      <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
        <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/spring/part1.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
      </a>
      <indexTitle
        title1="报名享四重好礼"
        title2="选绵阳欧米奇-上市品牌-更专业的西式餐饮学校"
        color="#be0000"
        lineColor="#be0000"
      ></indexTitle>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/up/part2.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <div style="width:100%;height:10px;"></div>
      <Button
        type="warning"
        size="large"
        style="background:#be0000;color: #fff;height:41px}"
        :loading="loading"
        v-on:click="send"
        long
        >点击咨询详情</Button
      >
      <div style="width:100%;height:25px;"></div>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/up/part3.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <indexTitle
        title1="八大核心教学优势"
        title2="选择大于努力，不只是欧米奇的实力，更是你的优势"
        color="#be0000"
        lineColor="#be0000"
      ></indexTitle>
      <van-image
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/up/part4.jpg"
      >
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <indexTitle
        title1="了解课程 了解学费"
        title2="预约你的精彩未来"
        color="#be0000"
        lineColor="#be0000"
      ></indexTitle>
      <springForm
        color="#fff"
        bag="#be0000"
        words="预约报名，优先抢占春季班名额"
      ></springForm>
    </div>
    <div class="h25px" style="width:100%;height:25px;"></div>
    <foot></foot>
  </div>
</template>
<script>
export default {
  data() {
    return {
     
    };
  },
  components: {
    springHead: () => import("../../../components/head/springHead"),
    landingBanner: () => import("../../../components/common/landing-banner"),
    foot: () => import("@/components/foot/foot"),
    indexTitle: () => import("@/components/common/indexTitle"),
    springTitle: () => import("@/components/common/springTitle"),
    find: () => import("@/components/common/find"),
    tab2: () => import("@/components/common/tab2"),
    springForm: () => import("@/components/form/springForm"),
    srcoll: () => import("@/components/common/srcoll")
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
.main {
  margin-top: 50px;
}
.content {
  padding: 10px;
}
.advantage4 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.advantage4-one {
  width: 49.5%;
}
</style>
